module.exports = { isAppForeground };

function isAppForeground({ selectors, state } = {}) {

    return !(typeof document !== 'undefined' && document.hidden)
        && !(state != null && selectors?.getIsAppInBackground?.(state));
}
